const state = () => ({
  leads: [],
  pagination: {
    totalResults: 0,
    totalPages: 1,
    prevPage: 1,
    currentPage: 1,
    nextPage: 1,
    perPage: 20
  },
  leadFields: [],
});

const getters = {
  leads: state => {
    return state.leads;
  },
  leadsPagination: state => {
    return state.pagination;
  },
  leadFields: state => {
    return state.leadFields;
  }
};

const actions = {
  async fetchLeads({ commit, state }, { currentPage, perPage, status, origin } = {}) {
    const { data, headers } = await this.$http.get(`/site-leads`, {
      params: {
        status,
        origin,
        orderById: 'DESC',
        limit: perPage || state.pagination.perPage,
        page: currentPage || state.pagination.currentPage
      }
    });
    commit("setLeads", { data, headers });
  },
  async fetchLead({}, { id }) {
    const { data } = await this.$http.get(`/site-leads/${id}`);
    return data;
  },
  async fetchLeadFields({ commit }) {
    const { data } = await this.$http.get(`/site-leads/fields`);
    commit("setLeadFields", data);
  },
  async fetchScore({}, { id, type, planId, loyalty }) {
    const { data } = await this.$http.get(`/site-leads/${id}/score`, { params: { type, planId, loyalty }});
    return data;
  },
  async processLead({}, { id, body }) {
    await this.$http.post(`/site-leads/${id}/process`, body);
  },
  async addLead({ commit }, { lead }) {
    const { data } = await this.$http.post(`/site-leads`, lead);
    commit("pushLead", data);
  },
  async updateLead({ commit }, { id, body }) {
    const { data } = await this.$http.patch(`/site-leads/${id}`, body);
    commit("refreshLead", data);
  },
  async removeLead({ commit }, { id }) {
    await this.$http.delete(`/site-leads/${id}`);
    commit("delLead", id);
  },
  async toggleForceAllowLeadCreation({ commit }, { id }) {
    const { data } = await this.$http.post(`site-leads/${id}/toggleForceAllowCreation`);
    commit('setLeadForceAllowCreation', data);
    return data;
  }
};

const mutations = {
  setLeads(state, { data, headers }) {
    state.leads = data;
    state.pagination.totalResults = +headers["x-total-results"];
    state.pagination.totalPages = +headers["x-total-pages"];
    state.pagination.prevPage = +headers["x-total-pages"];
    state.pagination.currentPage = +headers["x-current-page"];
    state.pagination.nextPage = +headers["x-next-page"];
    state.pagination.perPage = +headers["x-per-page"];
  },
  setLeadFields(state, data) {
    state.leadFields = data;
  },
  refreshLead(state, data) {
    state.leads = [...state.leads.map(item => item.id !== data.id ? item : {...item, ...data})]
  },
  pushLead(state, data) {
    state.leads.unshift(data);
  },
  delLead(state, id) {
    state.leads = state.leads.filter(c => c.id != id);
  },
  setLeadForceAllowCreation(state, toggle) {
    if (state.lead) {
      state.lead.forceAllowCreation = toggle;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
